
export class Time {

  private h: number = 0;
  private m: number = 0;

  constructor(h: number, m: number) {
    if (h < 0 || h > 24) {
      throw new Error("The hour must be between 0 and 24");
    }

    if (m < 0 || m > 59) {
      throw new Error("The minute must be between 0 and 59");
    }

    this.h = h;
    this.m = m;
  }

  minuteInDay = () => {
    return this.h * 60 + this.m;
  }

  compare = (otherTime: Time) : number => {
    return this.minuteInDay() - otherTime.minuteInDay();
  }

}

export const timeFromString = (timeString: string | undefined) : Time | undefined => {
  if (!timeString) {
    return;
  }

  const match = timeString.trim().match(/^(\d{1,2}):(\d{1,2})$/);
  if (!match) {
    return undefined;
  }

  try {
    const time = new Time(Number(match[1]), Number(match[2]));
    return time;
  } catch (e) {
    return;
  }
}
